import { useContext } from 'react';
import MatrixContext from './context';

const useMatrixContext = () => {
  const context = useContext(MatrixContext);
  return context;
};

export { useMatrixContext };
